import { styled } from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledProcessPurchase = styled('div')`
  .form-summary-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10%;
    padding-top: 30px;

    .form-wrapper {
      width: 100%;

      .form-title {
        font-size: 24px;
        font-weight: 400;
        padding-bottom: 18px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .form-summary-wrapper {
      .form-wrapper {
        .form-title {
          font-size: 1.125rem;
        }

        .ant-form {
          .ant-form-item-label {
            label {
              font-size: 1rem;
            }
          }
        }
      }

      .purchase-form-title {
        font-size: 1rem;
      }
    }
  }

  @media only screen and (max-width: 900px) {
    .form-summary-wrapper {
      flex-direction: column;
      .form-wrapper {
        .form-title {
          margin-top: 14px;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .form-summary-wrapper {
      padding-top: 0;
      .form-wrapper {
        .form-title {
          margin-top: 10px;
          font-weight: 600;
          padding-bottom: 0;
        }
      }
    }
  }
`;
